export default import.meta.ROLLDOWN_FILE_URL_xHF4xcH6Oh9LkyqMogJl9w